import React from 'react';
import { hot } from 'react-hot-loader/root';
import { Theme, presetGpnDefault } from '@consta/uikit/Theme';
import App from './App';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import history from 'src/history/history';
import store from './redux/store';

const AppWrapper = () => {
  return (
    <Provider store={store}>
      <Theme preset={presetGpnDefault}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Theme>
    </Provider>
  );
};

export default hot(AppWrapper);
